import React from 'react';

function UserAvatar(props: object) {
  return (
    <svg
      width="87"
      height="87"
      viewBox="0 0 87 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M44.0793 39.4038C43.7168 39.3675 43.2818 39.3675 42.883 39.4038C34.2555 39.1138 27.4043 32.045 27.4043 23.345C27.4043 14.4638 34.5818 7.25 43.4993 7.25C52.3805 7.25 59.5943 14.4638 59.5943 23.345C59.5581 32.045 52.7068 39.1138 44.0793 39.4038Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9563 52.78C17.1838 58.6525 17.1838 68.2225 25.9563 74.0587C35.9251 80.7287 52.2738 80.7287 62.2426 74.0587C71.0151 68.1862 71.0151 58.6162 62.2426 52.78C52.3101 46.1463 35.9613 46.1463 25.9563 52.78Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UserAvatar;
